// React
import React from 'react';

// Styles
import styles from './Logo.module.scss';
import { ReactComponent as LogoSvg } from '../../../images/logo-black.svg';

// Third party
import { Link as RouterLink } from 'react-router-dom';

// Material UI
import { Link } from '@material-ui/core';

// This component
export default function Logo() {
  // JSX
  return (
    <Link component={RouterLink} underline="none" to="/">
      <LogoSvg className={styles.logo} />
    </Link>
  );
}
